import { render } from "./invoices-list-modal.vue?vue&type=template&id=5e528332"
import script from "./invoices-list-modal.vue?vue&type=script&lang=js"
export * from "./invoices-list-modal.vue?vue&type=script&lang=js"

import "./invoices-list-modal.vue?vue&type=style&index=0&id=5e528332&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__